<!-- certificate-value-node-editor.component.html -->
<div class="value-node-item" [class]="{'has-children': hasChildren}">
    <!-- Header -->
    <div class="value-node-header">
        <div class="node-label">
            {{ templateNode.name }}
            @if (!hasChildren) {
                <span class="type-label">
                    ({{ templateNode.type === 'number' ? 'Zahl' : 'Text' }})
                </span>
            }
        </div>

        <!-- Leaf node: show value input -->
        @if (!hasChildren) {
            <mat-form-field appearance="outline" class="value-field">
                @if (templateNode.type === 'string') {
                    <input matInput [(ngModel)]="valueNode.value"
                        (ngModelChange)="onValueChanged()" [placeholder]="templateNode.name">
                } @else if (templateNode.type === 'number') {
                    <input matInput type="number" [(ngModel)]="valueNode.value"
                        (ngModelChange)="onValueChanged()" [min]="templateNode.min" [max]="templateNode.max"
                        [placeholder]="templateNode.name">
                }
            </mat-form-field>
        }
    </div>

    <!-- Group: show children inside a visual container -->
    @if (hasChildren && valueNode.children) {
        <div class="value-node-children">
            <div class="group-box">
                @for (childTmpl of templateNode.children; track childTmpl.id || $index) {
                    <app-template-value-node-editor
                        [templateNode]="childTmpl" [valueNode]="valueNode.children[$index]" (valueChange)="onChildValueChange()">
                    </app-template-value-node-editor>
                }
            </div>
        </div>
    }
</div>